import { render, staticRenderFns } from "./LaporanClient.vue?vue&type=template&id=1034b5f6&"
import script from "./LaporanClient.vue?vue&type=script&lang=js&"
export * from "./LaporanClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LaporanClient.vue"
export default component.exports